import React from "react";
import styles from "./InteractionContainer.module.scss";
import BreadCrumbs from "../BreadCrumbs"
import { prop } from "cheerio/lib/api/attributes";

const Frame = () => <img src={'media/img/background/border.svg'} className={styles.frame} alt=""/>;

const InteractionContainer = (props) => {

  const { variant, withFrame, breadcrumbs, children } = props

  const setBGVariant = (variant) =>{

    let bgImg

    switch (variant) {
      default:
      case 'grid':
        bgImg = 'url(media/img/background/repeat-grid.png) no-repeat center center'
        break

      case 'starfield':
        bgImg = 'url(media/img/background/starfield.png) no-repeat center center'
        break
    }

    return bgImg

  }

  return(
    <div
      className={styles.InteractionContainer}
      style={{  background: setBGVariant(variant) }}>

        {children}

        {
          // Breadcrumbs position is fixed for now
          // at bottom left corner
          breadcrumbs &&
            <div className={styles.breadcrumbs}>
              <BreadCrumbs breadcrumbs={breadcrumbs}  />
            </div>
        }

        {withFrame && <Frame />}

    </div>
  )
};

export default InteractionContainer;
